import React from 'react';

function KeyMinimalistic02({ fill, ...restProps }) {
  return (
    <>
      <svg
        fill={fill ?? ''}
        viewBox='0 0 24 24'
        xmlns='http://www.w3.org/2000/svg'
        {...restProps}
      >
        <path
          d='M11.833 1.371a6.673 6.673 0 0 0-4.036 1.926C6.651 4.443 5.996 5.87 5.86 7.517c-.124 1.497.338 3.136 1.23 4.365l.144.199-2.499 2.501c-1.923 1.926-2.514 2.536-2.566 2.651a.95.95 0 0 0-.007.684c.136.3.421.482.755.482.252 0 .413-.072.65-.291l.183-.168.368.359c.446.435.583.515.882.515A.792.792 0 0 0 5.814 18c0-.299-.08-.436-.517-.883l-.361-.37.239-.239.239-.239.369.361c.447.437.584.518.884.518a.792.792 0 0 0 .814-.815c0-.299-.08-.436-.517-.883l-.361-.37.907-.907.908-.908.199.145c1.23.892 2.889 1.358 4.375 1.229a7.01 7.01 0 0 0 1.659-.341c.787-.271 1.01-.424 1.128-.774.068-.199.068-.266.001-.493a.836.836 0 0 0-.554-.546c-.235-.069-.337-.052-.793.131-2.288.916-4.771.15-6.119-1.887a4.987 4.987 0 0 1 0-5.458 5.045 5.045 0 0 1 2.944-2.119c2.069-.529 4.235.317 5.428 2.119a4.973 4.973 0 0 1 .765 3.429c-.083.612-.243 1.101-.556 1.698-.166.317-.198.541-.115.792a.921.921 0 0 0 .466.49c.317.13.764.011.957-.256.118-.163.421-.783.541-1.107.918-2.479.266-5.311-1.641-7.126a6.702 6.702 0 0 0-5.27-1.82m.265 4.162a2.58 2.58 0 0 0-1.405.761c-.277.294-.43.55-.564.941-.101.294-.108.345-.108.765 0 .421.008.471.11.774a2.506 2.506 0 0 0 2.076 1.701c1.245.153 2.41-.662 2.73-1.911.029-.112.045-.34.043-.597-.003-.378-.013-.447-.112-.741a2.482 2.482 0 0 0-2.24-1.708 3.49 3.49 0 0 0-.53.015m.735 1.703a.79.79 0 0 1 .421.414.832.832 0 1 1-1.586.35.88.88 0 0 1 .226-.579.87.87 0 0 1 .939-.185'
          fill-rule='evenodd'
          fill={fill ?? ''}
        />
      </svg>
    </>
  );
}

export default KeyMinimalistic02;
